import React from 'react';
import Odj from './Tabs/Odj';
import Extract from './Tabs/Extract';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/icons/List';
import Send from '@material-ui/icons/Send';
import Button from '@material-ui/core/Button';
import Utils from '../Utils/Utils';

const styles = theme => ({
  root: {
    backgroundColor: Utils.hexToRGB(theme.palette.background.paper, window.sdk.isOverlay() ? 0.8 : 1),
    color: theme.palette.background.txt
  },
});

class FullWidthTabs extends React.Component {
  state = {
    value: 0,
    loading: true,
    liveOdj: false
  };
  tabs = ['odj', 'extract'];
  
  async componentDidMount() {
    if (window.live) {
      
      if(window.sdk.isOdjOnly()) {
        await this.setState({
          loading: false
        })
        this.show('odj');
        //window.sdk.player().destroy();
        document.querySelector('.left').style.width = '0%';
        document.querySelector('.right').style.width = '100%';
        document.querySelector('.odj').style.marginTop = '60px';
      }
      else {
        await this.setState({
          loading: false
        })
        this.show('odj');
        this.forceUpdate();
      }
      
      window.sdk.on('play', async (data) => {
        await window.sdk.live.loadCuepoints();
        await this.setState({
          loading: true
        })
        await this.setState({
          loading: false,
          liveOdj: true
        })
        this.show('odj');
        if (window.sdk.isExtended() && document.body.clientWidth >= 768) {
          this.show(this.tabs[1]);
          this.show(this.tabs[0]);
        }
   
   
        if (window.sdk.isOverlay()) {
          this.hideCurrentTab();
        }
      });
    }
    else {
      await this.setState({
        loading: false
      })
      this.show('odj');
    }
   
    window.sdk.on('showExtract', (data) => {
      this.setState({
        value: 1
      })
      this.show('extract', data.index)
    });
   
   
    if (window.sdk.isOverlay()) {
      this.hideCurrentTab();
      
      window.sdk.on('closeTabs', () => {
        this.hideCurrentTab();
      });
    }
    
    
    document.addEventListener("mousedown", this.handleClickOutside);

    if (window.sdk.isExtended() && document.body.clientWidth >= 768) {
      this.show(this.tabs[1]);
      this.show(this.tabs[0]);
    }
  }
  
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  
  hideCurrentTab = () => {
    for(var i in this.tabs) {
      this.refs[this.tabs[i]].show(false);
    }
  }
  
  show = (tab, index = -1) => {
    for(var i in this.tabs) {
      if(this.tabs[i] != tab)
        this.refs[this.tabs[i]].show(false);
    }
    this.refs[tab].show(true, index);
      
  }
  
  handleChange = async (event, value) => {
    await this.setState({ value });
    this.show(this.tabs[value]);
  };
  
  handleClickOutside = (e) => {
    if (window.sdk.isOverlay()) {
      let notTargeted = ['tab-odj-block', 'tab-extract-block', 'tab-odj-toggle', 'tab-extract-toggle'];
      let outside = true;
      
      for(let item of notTargeted) {
        let itemNode = document.querySelector('.'+item);
        if (e.target.classList.contains(item) || (itemNode && itemNode.contains(e.target))) {
          outside = false;
        }
      }
      
      if (outside) {
        this.hideCurrentTab();
      }
    }
  };

  render() {
    const { classes, theme } = this.props;
    
    if(this.state.loading)
      return null;
    
    return (
      <div className={classes.root}>
      
        { !window.sdk.isOdjOnly() && !window.sdk.isOverlay() && 
        <div className="tabs-wrapper">
          <AppBar position="static" color="default" className={classes.root}>
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor="inherit"
              style={{ backgroundColor: window.theme.palette.background.paper }}
              id="bs-left-tab"
            >
              <Tab label="Programme" id="bs-left-tab-odj" />
              { window.custom === false && !window.local &&
                <Tab label="Extrait" id="bs-left-tab-extrait"  />
              }
              { ((window.custom.synople && window.custom.synople.extraits !== false && !window.local) || window.query.showextract) &&
                <Tab label="Extrait" id="bs-left-tab-extrait"  />
              }
            </Tabs>
          </AppBar>
        </div>
        }
        
        { !window.sdk.isOdjOnly() && window.sdk.isOverlay() && 
        <div className="tabs-overlay__buttons">
          <Button variant="contained" id="bs-left-tab-odj" color="primary" aria-label="Programme" className={ 'tabs-overlay__button tab-odj-toggle ' + (this.state.value === 0 ? 'tabs-overlay__button--active' : '') } onClick={(e) => this.handleChange(e, 0)}>
            <List />
          </Button>
          { window.custom === false && !window.local &&
            <Button variant="contained" color="primary" aria-label="Extrait" className={ 'tabs-overlay__button tab-extract-toggle ' + (this.state.value === 1 ? 'tabs-overlay__button--active' : '') } onClick={(e) => this.handleChange(e, 1)}>
              <Send />
            </Button>
          }
          { window.custom.synople && window.custom.synople.extraits !== false && !window.local &&
            <Button variant="contained" color="primary" aria-label="Extrait" className={ 'tabs-overlay__button tab-extract-toggle ' + (this.state.value === 1 ? 'tabs-overlay__button--active' : '') } onClick={(e) => this.handleChange(e, 1)}>
              <Send />
            </Button>
          }
        </div>
        }
        
        <div id="tab_inner" className="tab_inner">
         
            <Odj ref="odj" liveOdj={ this.state.liveOdj } />
         
            {!window.local && <Extract ref="extract" /> }
         
        </div>
      </div>
    );
  }
  
}

FullWidthTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(FullWidthTabs);



// WEBPACK FOOTER //
// ./src/Player/Tabs.js